import state from '../../../store/state';

export default {
  user: {},
  token: null,
}



// WEBPACK FOOTER //
// ./src/app/auth/vuex/state.js